// extracted by mini-css-extract-plugin
export default {"label":"ValueRangeFilter_label__It-A3","inputs":"ValueRangeFilter_inputs__lf8X2","input":"ValueRangeFilter_input__49NL5"};